const ko = {
  home: {
    biometric_label: "생체 인식 신원 확인",
    title: "얼굴 역방향 검색을 쉽게",
    description:
      "고해상도 초상화를 업로드하여 고급 신경망 매칭을 사용해 전 세계 디지털 아카이브와 교차 참조하세요.",
    drag_drop: "이미지를 끌어다 놓으세요",
    file_formats: "RAW, JPEG 또는 PNG 지원 (최대 15MB)",
    select_file: "시스템에서 파일 선택",
    initiate_scan: "포렌식 스캔 시작",
    upload_hint: "계속하려면 이미지를 업로드하세요",
    uploading: "업로드 중",
    searching: "스캔 중",
    result_title: "결과",
    drop_here: "여기에 이미지를 놓으세요...",
    billion_faces: "인터넷의 10억 개 이상의 얼굴과 비교",
    login_to_search: "검색하려면 로그인",
    login_required: "이 앱을 사용하려면 로그인하거나 계정을 만드세요",
    not_enough_tokens: "토큰이 부족합니다",
    please_wait: "몇 분 기다려 주세요",
    leave_confirmation: "프로세스가 진행 중입니다. 페이지를 떠나시겠습니까?",
  },
  sources: {
    section_title: "검색 대상 소스",
    social_media: {
      name: "소셜 미디어",
      description: "주요 소셜 네트워크 및 공개 프로필 교차 참조.",
    },
    web: {
      name: "웹",
      description: "공개적으로 사용 가능한 얼굴 데이터에 대해 오픈 웹을 스캔.",
    },
    scammers: {
      name: "사기꾼",
      description: "알려진 사기꾼 신원 및 사기 데이터베이스와 매칭.",
    },
    sexual_offenders: {
      name: "성범죄자",
      description: "공개 등록 성범죄자 데이터베이스와 교차 참조.",
    },
    videos: {
      name: "동영상",
      description: "공개 동영상 플랫폼에서 얼굴 추출 및 매칭.",
    },
    police_photos: {
      name: "경찰 사진",
      description: "공개적으로 사용 가능한 경찰 기록 데이터베이스와 비교.",
    },
    news_and_blogs: {
      name: "뉴스 & 블로그",
      description: "뉴스 아카이브, 편집 콘텐츠 및 블로그 검색.",
    },
  },
  header: {
    scan: "스캔",
    history: "기록",
    pricing: "가격",
    account: "계정",
    logout: "로그아웃",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright: "© 2024 Digital Forensicist. 모든 권리 보유. 정밀 신원 확인.",
    privacy: "개인정보 처리방침",
    terms: "서비스 약관",
    docs: "문서",
    support: "지원",
  },
  common: {
    loading: "로딩 중...",
    error: "오류",
    cancel: "취소",
    back: "뒤로",
  },
  errors: {
    upload_failed: "업로드 실패. 다시 시도하세요.",
    not_enough_tokens: "이 검색을 수행할 충분한 토큰이 없습니다.",
  },
  login: {
    disclaimer:
      "이 앱을 사용하려면 계정이 필요합니다. 스팸을 보내거나 이메일을 공유하지 않습니다. 개인 정보 보호를 위해 Apple로 로그인하는 것을 권장합니다.",
  },
  results: {
    input_source: "입력 소스",
    match_thumbnail: "일치 이미지 썸네일",
    extraction_id: "추출 ID",
    scan_analysis: "스캔 분석",
    scan_description:
      "생체 인식 역방향 검색이 완료되었습니다. 공개 레지스트리 및 소셜 인덱스에서 %{count}개의 잠재적 일치 항목을 찾았습니다.",
    col_identity_map: "신원 맵",
    col_verification_path: "검증 경로",
    col_bio_match_score: "바이오 매치 점수",
    col_action: "작업",
    export_pdf: "PDF 내보내기",
    exporting: "생성 중...",
    verified: "확인됨",
    details: "세부 정보",
    details_tooltip: "정밀 얼굴 비교 실행",
    details_loading: "비교 중...",
    copied: "복사됨!",
    copy_url: "URL 복사",
    displaying: "%{total}개 중 %{count}개 표시",
  },
};

export default ko;
